import React from 'react';
import cN from 'classnames';
import { Tag } from '@lion-design/core';
import * as Icons from '@components/Common/Icons';
import './styles.scss';

interface I_Parameters {
    text: string;
    isActive?: boolean;
    isHalfRadius?: boolean;
    isClosable?: boolean;
    tripType?: string;
    onClick?: any;
    onClose?: any;
    className?: string;
}

function appendIcon({ text, isActive, tripType = '' }: I_Parameters) {
    const iconFill = isActive ? '#fff' : '#222';

    switch (tripType) {
        case '01':
            return (
                <>
                    <Icons.Cruise fill={iconFill} />
                    {text}
                </>
            );
        case '02':
            return (
                <>
                    <Icons.Bus fill={iconFill} />
                    {text}
                </>
            );
        case '03':
            return (
                <>
                    <Icons.Train fill={iconFill} />
                    {text}
                </>
            );
        case '04':
            return (
                <>
                    <Icons.AirPlane fill={iconFill} />
                    {text}
                </>
            );
        default:
            return text;
    }
}

function appendFeaturedIcon({ text }: I_Parameters) {
    //新增標籤icon地方，須補判斷
    switch (text) {
        case 'vac':
        case '自由行':
            return (
                <>
                    <div className="IconWrap">
                        <Icons.Walk fill="#666" />
                    </div>
                    <span className="slash" />
                    自由行
                </>
            );
        case 'grp':
        case '團體':
        case '團':
            return (
                <>
                    <div className="IconWrap">
                        <Icons.SuitCase fill="#666" />
                    </div>
                    <span className="slash" />
                    團體
                </>
            );
        case 'htl':
        case '訂房':
            return (
                <>
                    <div className="IconWrap">
                        <Icons.Bed fill="#666" />
                    </div>
                    <span className="slash" />
                    訂房
                </>
            );
        case 'etk':
        case '票券':
            return (
                <>
                    <div className="IconWrap">
                        <Icons.Ticket fill="#666" />
                    </div>
                    <span className="slash" />
                    票券
                </>
            );
        case 'flt':
        case '機票':
            return (
                <>
                    <div className="IconWrap">
                        <Icons.AirPlane fill="#666" />
                    </div>
                    <span className="slash" />
                    機票
                </>
            )
        default:
            return text;
    }
}

export const Normal: React.FC<I_Parameters> = (params) => (
    <Tag className={cN('normal', params.className)} onClick={params.onClick}>
        {appendIcon(params)}
    </Tag>
);
export const Selectable: React.FC<I_Parameters> = (params) => (
    <Tag
        className={cN('selectable', { active: params.isActive })}
        closable={params.isClosable || false}
        onClose={params.onClose}
    >
        {appendIcon(params)}
    </Tag>
);
export const Featured: React.FC<I_Parameters> = (params) => {
    const featuredClass = '';

    // switch (params.text) {
    //     case '會員限購':
    //         featuredClass = 'vip';
    //         break;
    //     case '郵輪優先選房號':
    //         featuredClass = 'cruise';
    //         break;
    //     case '雄獅推薦':
    //         featuredClass = 'lion';
    //         break;
    // }

    return (
        <Tag className={cN('featured', featuredClass, { halfRaidus: params.isHalfRadius })}>
            {appendFeaturedIcon(params)}
        </Tag>
    );
};
